import { useMutation } from "@tanstack/react-query";

import { sessionApi } from "@shared/api";

export const useDeleteAllSessions = () => {
  const { error, mutateAsync, isPending } = useMutation({
    mutationFn: () => sessionApi.deleteApiV1Sessions(),
  });

  return { deleteAllSessions: mutateAsync, error, isPending };
};
